import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import Swal from "sweetalert2";
import { FaRegTrashCan } from "react-icons/fa6";
import axios from "axios";


function AltaFaltante() {
 const [masterEncontrado, setMasterEncontrado] = useState(false);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  const [vuelosDisponibles, setVuelosDisponibles] = useState([]);
  const [formData, setFormData] = useState({
    master: "",
    vueloLlegada: "",
    piezas: "",
    peso: "",
  });

  const initialFormState = {
    master: "",
    vueloLlegada: "",
    piezas: "",
    peso: "",
  };

  const handleBuscarMaster = async () => {

    if (!formData.master) {

      Swal.fire("Atención", "Por favor ingresa un número de Master", "info");
      return;
    }
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_TRANSIT}/api/v1/add_extras/searchMaster`,
        {
          params: {
            awb: formData.master
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          }
        }
      );
      const res_fligth = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_TRANSIT}/api/v1/add_extras/getFlights`,
        {
          params: {
            awb: formData.master
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          }
        }
      );
      if (res_fligth.data === 'false' || !res_fligth.data) {
        setVuelosDisponibles([]);
        setFormData(prev => ({ ...prev, vueloLlegada: "" })); // Limpiamos selección previa
      } else {
        setVuelosDisponibles(res_fligth.data);
        setFormData(prev => ({ ...prev, vueloLlegada: "" })); // Limpiamos selección previa
      }
      // 2. Desestructuramos la respuesta del backend [status, data]
      const [status, data] = res.data;
      if (status === 1) {
        // 3. Mapeo de parámetros del Backend -> State del Frontend
        setFormData({
          ...formData,
          piezas: data.pieces,                  // 10
          peso: data.weight,                    // 200
        });
        setMasterEncontrado(true);
        setBusquedaRealizada(true);

        // Opcional: Notificación de éxito

        // Swal.fire("Éxito", "Datos de Master cargados", "success");
      } else {
        // Si el status es -1 o cualquier otro
        setMasterEncontrado(false);
        setBusquedaRealizada(true);
        Swal.fire("Atención", "No se encontró información para la Master: " + formData.master, "warning");
      }
    } catch (error) {
      console.error("Error en handleBuscarMaster:", error);
      setMasterEncontrado(false);
      // Manejo de errores específicos (ej. 401, 500)
      const msg = error.response?.data?.message || "Ocurrió un error al obtener los datos";
      Swal.fire("Error", msg, "error");
    }
  };

  const handleMasterChange = (e) => {
    let value = e.target.value;
    let numbersOnly = value.replace(/\D/g, "").slice(0, 11);

    let formatted =
      numbersOnly.length > 3
        ? `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3)}`
        : numbersOnly;

    setFormData({ ...formData, master: formatted });
  };

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleNumberChange = (field, value) => {
    const onlyNumbers = value.replace(/\D/g, "");
    setFormData({ ...formData, [field]: onlyNumbers });
  };

  const handleSave = async () => {
       try {
        // 1. Preparamos el cuerpo de la petición (Body)
        const master = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_TRANSIT}/api/v1/add_extras/searchMaster`,
        {
          params: {
            awb: formData.master
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          }
        }
      );
      const res_fligth = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_TRANSIT}/api/v1/add_extras/getFlights`,
        {
          params: {
            awb: formData.master
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          }
        }
      );    
        const dataToSend = {
            add_type: "3",
            awb: formData.master, // Usamos el valor del estado
            is_external: "2",
            flight_arrive:formData.vueloLlegada, // AM0026/20FEB
            year_arrive_select: master.anioLlegada,
            flight_exit: master.vueloSalida,
            year_exit_select: master.anioSalida,
            origin: master.data.origen,
            destination: master.data.destino,
            etd: master.etd,
            pieces: formData.piezas,
            weight: formData.peso,
            total_pieces: formData.piezasTotales,
            total_weight: formData.pesoTotal,
            volume: master.volumen,
            description: master.descripcion,
            required_temp: master.temperaturaId || "2" // Asegúrate de mandar el ID
        };


        // 2. Ejecutamos el POST
        const res = await axios.post(
            `${process.env.REACT_APP_URL_BACKEND_TRANSIT}/api/v1/add_extras/save`,
            dataToSend, // Segundo argumento: Datos
            {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                }
            } // Tercer argumento: Configuración
        );

        if (res.data.status === 'success') {
            Swal.fire("Guardado", "Alta generada con éxito", "success");
            // Aquí puedes limpiar el formulario o redireccionar
            
        } else {
            Swal.fire("Error", res.data.message, "error");
        }

    } catch (error) {
        console.error("Error al guardar:", error);
        const errorMsg = error.response?.data?.message || "Error interno al procesar la solicitud";
        Swal.fire("Error", errorMsg, "error");
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Master *</small>
            </label>

            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={formData.master}
                onChange={handleMasterChange}
              />

              <span
                className="input-group-text"
                style={{ cursor: "pointer" }}
                onClick={handleBuscarMaster}
              >
                <FaSearch />
              </span>
              <span
                className={`input-group-text ${formData.master ? "" : "text-muted"
                  }`}
                style={{
                  cursor: formData.master ? "pointer" : "not-allowed",
                }}
                onClick={() => {
                  setFormData(initialFormState);
                  setMasterEncontrado(false);
                  setBusquedaRealizada(false);
                }}
              >
                <FaRegTrashCan />
              </span>
            </div>

            <small>
              Clic en <FaSearch /> para buscar master existente
            </small>

            {busquedaRealizada && !masterEncontrado && (
              <small className="text-danger d-block mt-1">
                No se encontro la master indicada
              </small>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Vuelo de llegada*</small>
              <select
                className="form-select"
                // Importante: Guarda el ID (un string/number), NO el objeto completo
                value={formData.vueloLlegada}
                onChange={(e) => handleChange("vueloLlegada", e.target.value)}
              >
                <option value="">Selecciona...</option>

                {vuelosDisponibles.map((vuelo) => (
                  // 'vuelo' es un objeto {id: 101786, flight_number: "AM0001", ...}
                  // Usamos el ID como valor y el número para mostrar al usuario
                  <option key={vuelo.id} value={vuelo.id}>
                    {vuelo.flight_number}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Piezas*</small>
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.piezas}
              onChange={(e) => handleNumberChange("piezas", e.target.value)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Peso*</small>
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.peso}
              onChange={(e) => handleNumberChange("peso", e.target.value)}
            />
          </div>
        </div>

        <div className="row mt-3">
          <div className="d-flex justify-content-end">
            <button className="btnn" onClick={handleSave}>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AltaFaltante;
